module.exports = __webpack_public_path__ + "media/offers/offer-poziom-color@2x-5089da08.png";